/* eslint-disable default-case */
import React, { useEffect, useRef, useState } from "react";
import useLoadGoogleMaps from "./useLoadGoogleMaps";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";

const YOUR_API_KEY = "YOUR_API_KEY_HERE"; // Replace with your actual API key

const MapManual = ({ onAddressChange }) => {
  const loaded = useLoadGoogleMaps(YOUR_API_KEY);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);

  const [map, setMap] = useState(null);
  const [address, setAddress] = useState("");
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
  const [permissionDenied, setPermissionDenied] = useState(false);
  const cleanPlusCode = (address) => {
    return address.replace(/^[A-Z0-9+]{4,},\s*/i, "");
  };
  const handleSelectAddress = async (value) => {
    try {
      const cleanedAddress = cleanPlusCode(value);
      setAddress(cleanedAddress);
      const results = await geocodeByAddress(value);
      const latLng = await getLatLng(results[0]);
      const data = getCityStateCountryFromAddressResult(results[0]);

      setCoordinates(latLng);
      console.log("Selected coordinates:", latLng);
      console.log("Selected address data:", data);

      onAddressChange?.({
        latitude: latLng.lat,
        longitude: latLng.lng,
        city: data.city,
        area: data.city,
        address: cleanedAddress,
      });
    } catch (error) {
      console.error("Error fetching geocode:", error);
    }
  };

  const getCityStateCountryFromAddressResult = (result) => {
    let city = "",
      state = "",
      country = "";
    result.address_components.forEach((comp) => {
      comp.types.forEach((type) => {
        switch (type) {
          case "locality":
            city = comp.long_name;
            break;
          case "administrative_area_level_1":
            state = comp.long_name;
            break;
          case "country":
            country = comp.long_name;
            break;
        }
      });
    });
    return { city, state, country };
  };

  // Initialize map + autocomplete
  useEffect(() => {
    if (!loaded) return;

    const initMap = (lat, lng) => {
      const position = { lat, lng };
      const mapInstance = new window.google.maps.Map(mapRef.current, {
        center: position,
        zoom: 14,
      });
      const marker = new window.google.maps.Marker({
        map: mapInstance,
        position,
      });

      setMap(mapInstance);
      markerRef.current = marker;

      const geocoder = new window.google.maps.Geocoder();

      // Log initial address and fire onAddressChange
      geocoder.geocode({ location: position }, (results, status) => {
        if (status === "OK" && results[0]) {
          console.log("Initial map address:", results[0].formatted_address);
          handleSelectAddress(results[0].formatted_address);
        } else {
          console.warn("Initial address not found");
        }
      });

      // Autocomplete setup
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current
      );
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) return;

        const location = place.geometry.location;
        const newPos = { lat: location.lat(), lng: location.lng() };
        mapInstance.setCenter(newPos);
        marker.setPosition(newPos);

        console.log("Selected address:", place.formatted_address);
        handleSelectAddress(place.formatted_address);
      });

      autocompleteRef.current = autocomplete;
    };

    // Attempt to get user location
    const tryInitWithGeolocation = () => {
      if (!navigator.geolocation) {
        initMap(37.7749, -122.4194);
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          initMap(position.coords.latitude, position.coords.longitude);
        },
        (err) => {
          if (err.code === err.PERMISSION_DENIED) {
            setPermissionDenied(true);
          }
          // fallback location even if denied or error
          initMap(37.7749, -122.4194);
        },
        { enableHighAccuracy: true }
      );
    };

    tryInitWithGeolocation();
  }, [loaded]);

  const handleMyLocation = () => {
    if (!navigator.geolocation || !map) return;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setPermissionDenied(false);
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        map.setCenter(pos);
        markerRef.current.setPosition(pos);

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: pos }, (results, status) => {
          if (status === "OK" && results[0]) {
            setAddress(results[0].formatted_address);
            handleSelectAddress(results[0].formatted_address);
            console.log("My current address:", results[0].formatted_address);
          } else {
            console.warn("No address found");
          }
        });
      },
      (err) => {
        if (err.code === err.PERMISSION_DENIED) {
          setPermissionDenied(true);
        } else {
          alert("Geolocation failed.");
        }
      },
      { enableHighAccuracy: true }
    );
  };

  return (
    <>
      {permissionDenied && (
        <div
          style={{
            margin: "10px 0",
            padding: "10px",
            background: "#ffeeba",
            border: "1px solid #f5c6cb",
          }}
        >
          <p>
            Please enable location permissions in your browser to center the map
            on your location.
          </p>
        </div>
      )}
      {!permissionDenied && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <input
              ref={inputRef}
              type="text"
              placeholder="Enter a location"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              style={{ padding: "10px", width: "85%", marginBottom: "10px" }}
            />
            <button
              style={{
                // borderRadius: "50%",
                borderColor: "transparent",
                backgroundColor: "transparent",
                marginBottom: 10,
              }}
              onClick={handleMyLocation}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="40px"
                viewBox="0 0 22 22"
                width="40px"
                fill="#A0A0A0"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
              </svg>
            </button>
          </div>

          <div
            ref={mapRef}
            style={{ width: "100%", height: "800px", marginTop: "10px" }}
          />
        </>
      )}
    </>
  );
};

export default MapManual;
